/*@ngInject*/
const HeaderUtil = function ($state) {

    this.isActiveNavElement = function (type) {
        return $state.current.name.indexOf(type) !== -1;
    };
};

angular.module('gw-um-header')
    .service('headerUtil', HeaderUtil);
